angular.module('impactx.logouttimer').controller('LogoutTimerDialogCtrl', [
    '$scope',
    '$mdDialog',
    'themeFactory',
    'TranslationService',
    LogoutTimerDialogCtrl]);

function LogoutTimerDialogCtrl($scope, $mdDialog, themeFactory, TranslationService) {
    $scope.trns =
        {
            yes: TranslationService.get("yes"),
            timeOutIn: TranslationService.get("timeOutIn"),
            seconds: TranslationService.get("seconds"),
            questionStayLoggedIn: TranslationService.get("questionStayLoggedIn")
        };
    $scope.theme = themeFactory.getTheme();

    this.answer = function()
    {
        $mdDialog.hide();
    }
}